import { RoomPrivacyCategory } from "@/lib/services/room/RoomPrivacyCategory";
import IAsset from "@/models/asset/Asset";
import { ShiftWithBorrowerCount } from "@/models/shift/ShiftWithBorrowerCount";
import { ITeamMember } from "@/models/user/TeamMember";
import { create } from "zustand";

export interface IMaterialRequestItem {
  itemId: number;
  name: string;
  requestAmount: number;
  unit: string;
}

interface RoomBorrowingData {
  location: number;
  room_type: number;
  room: number;
  room_code: string;
  room_privacy_category: RoomPrivacyCategory;
  capacity: number;
  date: Date | undefined;
  shift: ShiftWithBorrowerCount[];
  team: ITeamMember[];
  phone: string;
  need_internet?: boolean;
  need_computer?: boolean;
  pc_count?: number;
  need_chemicals?: boolean;
  requested_materials: IMaterialRequestItem[];
  purpose: string;
  borrowing_reason_category: string;
  current_page: number;
  borrower_count: number;
  assets: IAsset[];
  is_private: boolean;
}

interface RoomBorrowingState {
  data: RoomBorrowingData;
  update: (
    field:
      | "location"
      | "room_type"
      | "room"
      | "room_code"
      | "room_privacy_category"
      | "capacity"
      | "date"
      | "shift"
      | "current_page"
      | "team"
      | "need_internet"
      | "need_computer"
      | "pc_count"
      | "need_chemicals"
      | "requested_materials"
      | "borrower_count"
      | "borrowing_reason_category"
      | "purpose"
      | "phone"
      | "assets"
      | "is_private",
    payload: any
  ) => void;
  setBorrowing: (borrowingData: RoomBorrowingData) => void;
  reset: () => void;
}

const defaultData: RoomBorrowingData = {
  location: -1,
  room_type: -1,
  room: -1,
  room_code: "",
  room_privacy_category: null,
  capacity: 0,
  date: undefined,
  shift: [],
  team: [],
  assets: [],
  phone: "",
  need_internet: false,
  need_computer: false,
  pc_count: 0,
  need_chemicals: false,
  requested_materials: [],
  borrower_count: 0,
  borrowing_reason_category: "",
  purpose: "",
  current_page: 0,
  is_private: false,
};

export const useRoomBorrowingStore = create<RoomBorrowingState>((set) => ({
  data: defaultData,
  update: (field, payload) => {
    set((state) => {
      const newData = { ...state.data, [field]: payload };

      if (field !== "current_page") {
        if (state.data.current_page === 0) {
          newData.room_type = -1;
          newData.room = -1;
          newData.room_code = "";
          newData.date = undefined;
          newData.shift = [];
          newData.team = [];
          newData.assets = [];
          newData.need_internet = false;
          newData.need_computer = false;
          newData.pc_count = 0;
          newData.need_chemicals = false;
          newData.requested_materials = [];
        } else if (state.data.current_page === 1) {
          newData.date = undefined;
          newData.shift = [];
          newData.assets = [];
          newData.need_internet = false;
          newData.need_computer = false;
          newData.pc_count = 0;
          newData.need_chemicals = false;
          newData.requested_materials = [];
        } else if (state.data.current_page === 2) {
          newData.assets = [];
          newData.need_internet = false;
          newData.need_computer = false;
          newData.pc_count = 0;
          newData.need_chemicals = false;
          newData.requested_materials = [];
        } else if (state.data.current_page === 3) {
          newData.need_internet = false;
          newData.need_computer = false;
          newData.pc_count = 0;
          newData.need_chemicals = false;
          newData.requested_materials = [];
        }
      }

      return { data: newData };
    });
  },
  setBorrowing: (borrowingData) => set(() => ({ data: { ...borrowingData } })),
  reset: () =>
    set({
      data: defaultData,
    }),
}));